import { useEffect, useRef } from 'react';

/**
 * true в том рендере, где `visible` перешла false→true (позднее появление видимости).
 *
 * `settled` — «значение уже вычислено». Правила видимости считаются асинхронно, а до первого
 * результата отдают стартовое `false`, поэтому первый переход в `true` после маунта — не смена
 * состояния, а окончание вычисления. Пока `settled === false` предыдущее значение не
 * запоминается, и такой переход не считается появлением видимости.
 *
 * На первичном рендере (`prev === undefined`) возвращает false. Нужен контролам формы,
 * чтобы в централизованном режиме выполнить invokeChanges-каскад, когда поле становится
 * видимым ПОСЛЕ стартовой инициализации (её один раз делает runInvokeChangesInit),
 * не дублируя каскад на первичном маунте.
 */
export function useBecameVisible(visible: boolean | undefined, settled: boolean = true): boolean {
    const prevRef = useRef<boolean | undefined>(undefined);
    const prev = prevRef.current;

    useEffect(() => {
        if (settled) prevRef.current = !!visible;
    });

    return settled && prev === false && !!visible;
}
